const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoNokia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1024 351",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer",
    transform: "matrix(0.425909,0,0,0.425909,177.661,96.8077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer2",
    d: "M1085.3,11.2L1137.3,11.2L1137.3,357.8L1085.3,357.8L1085.3,11.2ZM709.4,184.5C709.6,294.7 630.8,363.7 529.4,363.7C428,363.7 349.4,294.7 349.4,184.5C349.4,79 428,5.3 529.4,5.3C630.8,5.3 709.3,84.5 709.4,184.5ZM529.4,54.6C458.7,54.6 401.3,107.8 401.3,184.5C401.3,262.6 458.7,314.3 529.4,314.3C600.1,314.3 657.5,262.6 657.5,184.5C657.5,107.8 600.1,54.6 529.4,54.6ZM329.1,294.8L329.1,369L53.1,121.3L53.1,357.7L-0,357.7L-0,-0L329.1,294.8ZM941.7,11.2L1019.1,11.2L825.7,184.4L1019.1,357.7L941.7,357.7L748.6,184.4L941.7,11.2ZM1570,357.8L1512.8,357.8L1470.9,281L1281.4,281L1239.5,357.8L1182.3,357.8L1251.6,229.9L1443.7,229.9L1347.9,52.1L1376.2,-0L1570,357.8Z",
    style: {
      fill: "white"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNokia);
export default __webpack_public_path__ + "static/media/logo-nokia.07bcef879cd733eb9a28b8cb77396f13.svg";
export { ForwardRef as ReactComponent };